/*
 * CEC-396 — header drawer animations.
 *
 * The hamburger menu drawer already inherits the cart drawer's slide (it is a
 * Drawer subclass with open-from="left"); making its frosted panel ride the
 * sliding content part is pure CSS (see asheis.css).
 *
 * The SEARCH, however, is a plain DialogElement whose stock animation drops
 * the panel down from under the header. This patch replaces its enter/leave
 * animations with the cart drawer's exact motion — the frosted band slides in
 * from the RIGHT (and back out) over 0.3s with the same easing — leaving the
 * drawer's contents and background untouched.
 */
(function () {
  var EASE = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

  function patch() {
    var HeaderSearch = window.customElements.get('header-search');
    if (!HeaderSearch) return false;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DURATION = reduced ? 0 : 300;

    // The dialog base consumes `.finished` (a promise) and `.finish()`;
    // bundle the overlay + content animations behind that interface.
    //
    // `finished` must RESOLVE once both animations settle and NEVER reject.
    // A cancelled animation's `.finished` rejects (AbortError); the dialog
    // does `controls.finished.then(() => cleanup)` with no `.catch`, so a
    // rejection silently skips its after-show / after-hide cleanup — the step
    // that sets `display:none` and restores the DOM. When a quick open→close
    // (event timing after a cart cycle) cancels the prior animation, that
    // skipped cleanup left the search panel half-shown and re-toggling: the
    // flash. Swallowing the per-animation rejection makes cleanup always run.
    function settle(a) {
      return a.finished.then(function () {}, function () {});
    }
    function pair(a, b) {
      return {
        finished: Promise.all([settle(a), settle(b)]),
        finish: function () {
          try { a.finish(); } catch (e) {}
          try { b.finish(); } catch (e) {}
        }
      };
    }

    function animateParts(self, overlayFrames, contentFrames, holdEnd) {
      var overlay = self.getShadowPartByName('overlay');
      var content = self.getShadowPartByName('content');
      // Drop fills left over from the previous cycle so they can't stack.
      // (Cancelling rejects their `.finished`, but those belong to the prior
      // controls object the dialog already moved past — and `settle()` above
      // swallows it there too.)
      overlay.getAnimations().forEach(function (a) { try { a.cancel(); } catch (e) {} });
      content.getAnimations().forEach(function (a) { try { a.cancel(); } catch (e) {} });
      var o = overlay.animate(overlayFrames, { duration: DURATION, easing: EASE, fill: holdEnd ? 'forwards' : 'backwards' });
      var c = content.animate(contentFrames, { duration: DURATION, easing: EASE, fill: holdEnd ? 'forwards' : 'backwards' });
      return pair(o, c);
    }

    HeaderSearch.prototype.createEnterAnimationControls = function () {
      return animateParts(
        this,
        [{ opacity: 0 }, { opacity: 1 }],
        [{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }],
        false
      );
    };

    HeaderSearch.prototype.createLeaveAnimationControls = function () {
      // 'forwards' holds the off-screen end state for the microtask between
      // the animation finishing and the dialog actually hiding (no flash).
      return animateParts(
        this,
        [{ opacity: 1 }, { opacity: 0 }],
        [{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }],
        true
      );
    };

    return true;
  }

  if (!patch()) {
    window.customElements.whenDefined('header-search').then(patch);
  }
})();
